<template>

    <v-card color="#f5f5f5" v-observe-visibility="visibilityChanged">
        <v-toolbar tabs fixed light color="white">
            <v-btn icon @click.native="closeDialog" light>
                <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title v-if="selectedItem.id === 0">Add Purchase Order</v-toolbar-title>
            <v-toolbar-title v-else>Edit Purchase Order - {{selectedItem.purchase_orders_number}}</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-tabs slot="extension"
                    v-model="activeTab"
                    color="secondary"
                    dark
                    slider-color="primary"
                    class="fixSides"
                    show-arrows

            >
                <v-tab>PURCHASE ORDER</v-tab>
                <v-tab :disabled="tabsDisabled">OFFER POSITIONS</v-tab>
                <v-tab :disabled="tabsDisabled">ORDER POSITIONS</v-tab>
                <v-tab :disabled="sendPurchaseOrderConfirmationDisabled">SEND ORDER CONFIRMATION</v-tab>
            </v-tabs>

            <v-toolbar-items>
                <v-menu
                        transition="slide-y-transition"
                        :nudge-bottom="20"
                        :nudge-right="0"
                        :nudge-left="0">
                    <v-btn @click="openBottomSheet($vuetify.breakpoint.mdAndDown)" id="menu-button"
                           slot="activator"
                           icon>

                        <v-icon dark>more_vert</v-icon>
                    </v-btn>
                    <v-list v-show="$vuetify.breakpoint.lgAndUp">
                        <v-list-tile @click.native="saveAll()">
                            <v-list-tile-title>
                                <v-icon color="secondary">save</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click.native="deleteAll()">
                            <v-list-tile-title>
                                <v-icon color="red">delete</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-toolbar-items>

        </v-toolbar>

        <v-tabs-items class="fromTop" v-model="activeTab"
                      :touchless="touchless"
        >
            <v-tab-item>

                <v-layout wrap>
                    <v-container grid-list-md>
                        <v-flex xs12 md10 offset-md1 xl6 offset-xl3>
                            <v-hover>
                                <v-card slot-scope="{ hover }"
                                        :class="`elevation-${hover ? 4 : 1}`">
                                    <v-card-title class="headline">{{cardTitle}} Purchase Order
                                        <v-spacer></v-spacer>
                                        <v-autocomplete v-show="!getInitialLoading"
                                                        v-if="selectedItem.id > 0"
                                                        class="statusSelecter"
                                                        :items="statuses"
                                                        item-text="name"
                                                        item-value="id"
                                                        label="Purchase Order Status"
                                                        v-model="selectedItem.purchase_orders_status_id"
                                                        required
                                        ></v-autocomplete>
                                    </v-card-title>

                                    <v-card-title>

                                        <v-flex xs12 pr-3 pl-3>
                                            <v-subheader>Customer</v-subheader>
                                            <v-divider></v-divider>
                                        </v-flex>


                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-autocomplete v-show="!getInitialLoading"
                                                            clearable
                                                            :items="getCustomers"
                                                            label="Customer"
                                                            :search-input.sync="searchCustomer"
                                                            v-model="selectedItem.customers_id"
                                                            :loading="loading"
                                                            hide-details
                                                            item-value="id"
                                                            item-text="name"
                                            >
                                            </v-autocomplete>

                                        </v-flex>
                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-autocomplete v-show="!getInitialLoading"
                                                            clearable
                                                            :items="getCustomerBranchOffices"
                                                            label="Branch Office"
                                                            :search-input.sync="searchCustomerBranchOffice"
                                                            v-model="selectedItem.customers_branch_offices_id"
                                                            :loading="loading"
                                                            hide-details
                                                            item-value="id"
                                                            item-text="name"
                                            >
                                            </v-autocomplete>
                                        </v-flex>

                                        <v-flex xs12 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-autocomplete
                                                    clearable v-show="!getInitialLoading"
                                                    :items="getCustomerBranchOfficesContacts"
                                                    label="Contact Person"
                                                    :search-input.sync="searchCustomerBranchOfficeContact"
                                                    v-model="selectedItem.customers_branch_offices_contacts_id"
                                                    :loading="loading"
                                                    :filter="customContactFilter"
                                                    hide-details
                                                    item-value="id"
                                                    item-text="name"
                                            >

                                                <template slot="selection" slot-scope="data">
                                                    {{ data.item.title }} {{ data.item.firstname }} {{
                                                    data.item.lastname }}
                                                </template>

                                                <template slot="item" slot-scope="data">
                                                    <v-list-tile-content>
                                                        <v-list-tile-title
                                                        >
                                                            {{ data.item.title }} {{ data.item.firstname }} {{
                                                            data.item.lastname }}
                                                        </v-list-tile-title>
                                                        <!-- <v-list-tile-sub-title>
                                                             {{ data.item.email }}
                                                         </v-list-tile-sub-title>-->
                                                    </v-list-tile-content>
                                                </template>

                                            </v-autocomplete>
                                        </v-flex>

                                        <v-flex xs12 pr-3 pl-3>
                                            <v-subheader>Customer Purchase Order</v-subheader>
                                            <v-divider></v-divider>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-text-field v-show="!getInitialLoading"
                                                          label="Customer Purchase Order Number"
                                                          v-model="selectedItem.customer_purchase_order_number"
                                                          required
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <UploadDocumentPicker v-show="!getInitialLoading"
                                                                  v-model="uploadedDocument"
                                                                  label="Select PDF"
                                            >
                                            </UploadDocumentPicker>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-autocomplete v-show="!getInitialLoading"
                                                            clearable
                                                            v-model="selectedItem.currencies_id"
                                                            :items="getCurrencies"
                                                            label="Currency"
                                                            item-value="id"
                                                            item-text="name"
                                            />
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <v-layout>
                                                <v-spacer/>
                                                <DocumentTokenChip
                                                        v-show="selectedItem.documents_id !== 0 && !getInitialLoading"
                                                        :documentsId="selectedItem.documents_id"
                                                        :documentFilename="selectedItem.customer_purchase_order_number + '.pdf'"
                                                >
                                                </DocumentTokenChip>
                                            </v-layout>
                                        </v-flex>

                                      <v-flex xs12 pr-3 pl-3>
                                        <v-layout row wrap pb-2>
                                          <v-subheader>Proforma</v-subheader>
                                          <v-spacer/>
                                          <v-switch color="secondary" class="header-switch" v-model="selectedItem.proforma" label=""/>
                                        </v-layout>
                                        <v-divider/>
                                      </v-flex>

                                      <v-layout row wrap v-show="selectedItem.proforma">

                                        <v-flex xs12 md6 pl-4 pa-2>
                                          <FakeItem v-show="getInitialLoading">
                                          </FakeItem>
                                          <DatetimePicker v-show="!getInitialLoading"
                                                          locale="de-DE"
                                                          landscape
                                                          mysql
                                                          :width="width = 500"
                                                          label="Paid at"
                                                          v-model="selectedItem.proforma_paid_at"
                                                          format="DD.MM.YYYY"
                                                          dateOnly
                                          >
                                          </DatetimePicker>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                          <FakeItem v-show="getInitialLoading">
                                          </FakeItem>
                                          <DocumentTokenChip style="float: right"
                                            v-show="getProformaDocumentId!== 0 && !getInitialLoading"
                                            :documentsId="getProformaDocumentId"
                                            :documentFilename="getAttachmentFilenamePRO"
                                          >
                                          </DocumentTokenChip>
                                        </v-flex>

                                      </v-layout>

                                        <v-flex xs12 pr-3 pl-3>
                                            <v-subheader>Select unconfirmed offers</v-subheader>
                                            <v-divider></v-divider>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pr-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-text-field v-show="!getInitialLoading"
                                                          v-model="search"
                                                          append-icon="search"
                                                          label="Search"
                                                          single-line
                                                          hide-details
                                                          clearable
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 md12 pl-4 pa-2>

                                            <FakeTable v-show="getInitialLoading">
                                            </FakeTable>
                                            <v-data-table v-show="!getInitialLoading"
                                                          v-model="selectedOffers"
                                                          :headers="headers"
                                                          :items="unconfirmedOffers"
                                                          :pagination.sync="pagination"
                                                          :total-items=total
                                                          class="elevation-0"
                                                          :loading="loading"
                                                          :rows-per-page-items="rowsPageItems"
                                                          select-all
                                            >

                                                <template slot="headerCell" slot-scope="props">
                                                    <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                                        <span>
                                          {{ props.header.text }}
                                        </span>
                                                    </v-tooltip>
                                                </template>
                                                <template slot="items" slot-scope="props">
                                                    <tr>

                                                        <td>
                                                            <v-checkbox
                                                                    v-model="props.selected"
                                                                    color="secondary"
                                                                    hide-details
                                                            ></v-checkbox>
                                                        </td>
                                                        <td>{{ props.item.id }}</td>
                                                        <td class="text-xs-left">{{ props.item.offer_number }}</td>
                                                        <td class="text-xs-left">{{ props.item.account.firstname }}
                                                          {{props.item.account.lastname}}
                                                        </td>
                                                        <td class="text-xs-left">
                                                          {{props.item.customers_offers_status.name }}
                                                        </td>
                                                        <td class="text-xs-left"> {{ props.item.valid_until | toDateOnly }}
                                                        </td>
                                                    </tr>
                                                </template>
                                            </v-data-table>

                                        </v-flex>

                                        <v-flex xs12 pa-3>
                                            <v-subheader>Outgoing Contact</v-subheader>
                                            <v-divider></v-divider>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pr-4>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-autocomplete v-show="!getInitialLoading"
                                                            clearable
                                                            v-model="selectedItem.accounts_id"
                                                            :items="allAccounts"
                                                            label="Account"
                                                            item-value="id"
                                                            :filter="customContactFilter"
                                            >
                                                <template slot="item" slot-scope="data">
                                                    <v-list-tile-content>
                                                        <v-list-tile-title>
                                                            {{ data.item.title ? data.item.title : '' }}
                                                            {{data.item.firstname }} {{data.item.lastname }}
                                                        </v-list-tile-title>
                                                    </v-list-tile-content>
                                                </template>

                                                <template slot="selection" slot-scope="data">
                                                    {{ data.item.firstname }} {{ data.item.lastname }}
                                                </template>

                                                <template slot="no-data">
                                                    <v-layout wrap>
                                                        <v-flex xs12 pl-4 pr-4>
                                                            <v-btn @click.native="" block
                                                                   small flat color="secondary">Create
                                                                New Account
                                                                <v-icon>add</v-icon>
                                                            </v-btn>
                                                        </v-flex>
                                                    </v-layout>
                                                </template>
                                            </v-autocomplete>
                                        </v-flex>

                                    </v-card-title>
                                    <v-card-actions>
                                        <v-layout mt-2 pb-3 pr-3>
                                            <v-spacer></v-spacer>
                                            <v-btn dark color="secondary" @click.native="saveAndGoToNextTab(1)">
                                                Save
                                                <v-icon class="white--text" right>save</v-icon>
                                            </v-btn>
                                        </v-layout>
                                    </v-card-actions>
                                </v-card>
                            </v-hover>
                            <v-layout mt-5 row justify-end>

                            </v-layout>

                        </v-flex>

                    </v-container>
                </v-layout>
            </v-tab-item>
            <v-tab-item>
                <unconfirmedOfferPositions></unconfirmedOfferPositions>
            </v-tab-item>
            <v-tab-item>
                <orderPositions></orderPositions>
            </v-tab-item>
            <v-tab-item>
                <sendOrderConfirmation></sendOrderConfirmation>
            </v-tab-item>
        </v-tabs-items>
    </v-card>

</template>

<script>
import {
  Settings,
  Inquiry,
  Customer,
  CustomerBranchOffice,
  CustomerBranchOfficeContact,
  PurchaseOrder,
  Offer
} from '../../store/namespace-helper'

import unconfirmedOfferPositions from '../PurchaseOrders/UnconfirmedOfferPositions/UnconfirmedOfferPositions.vue'
import orderPositions from '../PurchaseOrders/OrderPositions/OrderPositions.vue'
import sendOrderConfirmation from '../PurchaseOrders/SendOrderConfirmation/SendOrderConfirmationMessage.vue'
import DatetimePicker from '../Shared/DatetimePicker.vue'
import UploadDocumentPicker from '../Shared/UploadDocumentPicker.vue'
import DocumentTokenChip from '../Shared/DocumentTokenChip.vue'
import FakeItem from '../Shared/FakeItem.vue'
import FakeTable from '../Shared/FakeTable.vue'

import {dateFunctionFilters} from '../../mixins/dateFunctionFilters'
import {initialLoadingMixin} from '../../mixins/initialLoadingMixin'

import _ from 'lodash'

export default {
  components: {
    unconfirmedOfferPositions,
    orderPositions,
    sendOrderConfirmation,
    DatetimePicker,
    UploadDocumentPicker,
    DocumentTokenChip,
    FakeItem,
    FakeTable
  },
  name: 'add-purchase-order',
  mixins: [dateFunctionFilters, initialLoadingMixin],
  data () {
    return {
      activeTab: 0,
      headers: [
        {text: 'Offer-ID', value: 'id'},
        {text: 'Offer Number', value: 'offer_number'},
        {text: 'Account', value: 'accounts_id'},
        {text: 'Status', value: 'customers_offers_status_id'},
        {text: 'Valid Until', value: 'valid_until'}
      ],
      countries: this.$store.getters.countries,
      selectedOffers: [],
      selectedOfferIDs: [],
      pagination: {'sortBy': 'id', 'descending': true},
      search: '',
      total: 0,
      rowsPageItems: [5, 10, 25, 50, 100, 250],
      customContactFilter (item, queryText, itemText) {
        const isMatch = (test, query) => {
          return test.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
        }
        const query = queryText || ''
        const displayText = item.title + ' ' + item.firstname + ' ' + item.lastname
        const rc = isMatch(item.firstname, query) ||
                        isMatch(item.lastname, query) ||
                        isMatch(item.email, query) ||
                        isMatch(displayText, query)
        console.log(`filter: ${JSON.stringify(item)}, '${query}', ${JSON.stringify(itemText)} => ${rc}`)
        return rc
      },
      isVisible: false,
      supplierContact: {},
      supplierUpdated: 0,
      onDismissed: false,
      sheet: false,
      searchCustomer: '',
      searchCustomerBranchOffice: '',
      searchCustomerBranchOfficeContact: '',
      valid_until: '',
      statuses: [],
      allAccounts: [],
      touchless: true,
      uploadedDocument: null
    }
  },
  mounted () {
    this.loadCustomers()
    this.loadCustomerBranchOffices()
    this.loadCustomerBranchOfficesContacts()
    this.loadCurrencies()
    this.loadTermsOfDeliveries()
    this.loadTermsOfPayments()
    this.loadStatuses()
    this.loadAllAccounts()
    this.initialLoadingTimeout(850)
  },
  methods: {
    visibilityChanged (isVisible, entry) {
      if (this.isVisible !== isVisible) {
        this.isVisible = isVisible
        if (isVisible) {
          console.log('tab visible, load data')
          this.loadCustomers()
          this.loadCustomerBranchOffices()
          this.loadCustomerBranchOfficesContacts()
          this.loadCurrencies()
          this.loadTermsOfDeliveries()
          this.loadTermsOfPayments()
          this.loadStatuses()
          this.loadAllAccounts()
          this.initialLoadingTimeout(850)
        } else {
          this.supplierUpdated = 0
          this.resetInitialLoadingState()
        }
      }
    },
    closeDialog () {
      this.$store.dispatch(PurchaseOrder.actions.openCloseDialog)
      this.$store.dispatch(PurchaseOrder.actions.setSelectedPurchaseOrder, null)

      this.activeTab = 0
    },
    loadCustomers () {
      const query = {
        search: this.searchCustomer ? this.searchCustomer : ''
      }
      this.$store.dispatch(Customer.actions.loadCustomers, query)
    },
    throttledLoadItems: _.debounce(function () {
      this.loadCustomers()
    }, 450),
    loadCustomerBranchOffices () {
      this.$store.dispatch(CustomerBranchOffice.actions.loadCustomerBranchOffices, this.selectedItem.customers_id)
    },
    throttledLoadUnconfirmedOffers: _.debounce(function () {
      this.loadUnconfirmedOffers()
    }, 450),
    loadUnconfirmedOffers () {
      const {sortBy, descending, page, rowsPerPage} = this.pagination
      const query = {
        sortBy: sortBy || 'id',
        descending: descending ? 'desc' : 'asc',
        page: page || 1,
        limit: rowsPerPage !== -1 ? rowsPerPage : 0,
        search: this.search ? this.search : '',
        customers_id: this.selectedItem.customers_id

      }
      this.$store.dispatch(Offer.actions.loadUnconfirmedOffers, query)
    },
    loadCustomerBranchOfficesContacts () {
      this.$store.dispatch(CustomerBranchOfficeContact.actions.loadContactPersons, this.selectedItem.customers_branch_offices_id)
    },
    loadCurrencies () {
      this.$store.dispatch(Settings.actions.loadAllCurrencies)
    },
    loadTermsOfPayments () {
      this.$store.dispatch(Settings.actions.loadTermsOfPayments)
    },
    loadTermsOfDeliveries () {
      this.$store.dispatch(Settings.actions.loadTermsOfDeliveries)
    },
    loadStatuses () {
      this.$store.dispatch(PurchaseOrder.actions.loadStatuses).then(response => {
        this.statuses = response.data.data
      })
    },
    loadAllAccounts () {
      this.$store.dispatch(Settings.actions.loadAllAccounts).then(response => {
        this.allAccounts = response.data.data
      })
    },
    saveAndGoToNextTab (index) {
      let purchaseOrder = {
        id: this.selectedItem.id,
        customers_id: this.selectedItem.customers_id,
        customers_branch_offices_id: this.selectedItem.customers_branch_offices_id,
        customers_branch_offices_contacts_id: this.selectedItem.customers_branch_offices_contacts_id,
        purchase_orders_status_id: this.selectedItem.customers_offers_status_id,
        accounts_id: this.selectedItem.accounts_id,
        selected_offers: this.selectedOfferIDs,
        documents_id: this.selectedItem.documents_id,
        customer_purchase_order_number: this.selectedItem.customer_purchase_order_number,
        currencies_id: this.selectedItem.currencies_id,
        proforma: this.selectedItem.proforma,
        proforma_paid_at: this.selectedItem.proforma_paid_at
      }

      this.$store.dispatch(PurchaseOrder.actions.savePurchaseOrder, purchaseOrder).then(response => {
        this.activeTab = index
      })
    },
    onDismissedError () {
      this.$store.dispatch(Settings.actions.clearNetworkError)
    },
    openBottomSheet (payload) {
      if (payload) {
        this.$store.dispatch('openCloseBottomSheet')
      }
    }
  },
  computed: {
    dialog () {
      return this.$store.getters[Inquiry.getters.getOpenInquiryDialogState]
    },
    selectedItem () {
      console.log('selected purchase order: ' + JSON.stringify(this.$store.getters[PurchaseOrder.getters.getSelectedPurchaseOrder]))
      return this.$store.getters[PurchaseOrder.getters.getSelectedPurchaseOrder]
    },
    getNetworkError () {
      return this.$store.getters[Settings.getters.getNetworkError]
    },
    getCustomers () {
      return this.$store.getters[Customer.getters.customers]
    },
    getCustomerBranchOffices () {
      return this.$store.getters[CustomerBranchOffice.getters.getCustomerBranchOffices]
    },
    getCustomerBranchOfficesContacts () {
      return this.$store.getters[CustomerBranchOfficeContact.getters.getContactPersons]
    },
    getCurrencies () {
      return this.$store.getters[Settings.getters.getAllCurrencies]
    },
    loading () {
      return this.$store.getters[Settings.getters.loading]
    },
    tabsDisabled () {
      return this.$store.getters[PurchaseOrder.getters.getSelectedPurchaseOrder].id === 0
    },
    sendPurchaseOrderConfirmationDisabled () {
      return this.$store.getters[PurchaseOrder.getters.getSelectedPurchaseOrder].messages_id === null
    },
    cardTitle () {
      if (this.selectedItem.id === 0) {
        return 'Add new'
      } else {
        return 'Edit'
      }
    },
    unconfirmedOffers () {
      this.total = this.$store.getters[Offer.getters.unconfirmedOffers].total
      return this.$store.getters[Offer.getters.unconfirmedOffers].data
    },
    getProformaDocumentId () {
      if (this.selectedItem.message && this.selectedItem.message.attachments) {
        if (this.selectedItem.message.attachments[1]) {
          return this.selectedItem.message.attachments[1].documents_id
        }
      }
      return 0
    },
    getAttachmentFilenamePRO () {
      return this.$store.getters[PurchaseOrder.getters.getSelectedPurchaseOrder].purchase_orders_proforma_number + '.pdf'
    }
  },
  watch: {
    pagination: {
      handler () {
        this.loadUnconfirmedOffers()
      },
      deep: true
    },
    uploadedDocument: {
      handler (val) {
        this.selectedItem.documents_id = val.id
        console.log('uploadedDocuments id: ' + JSON.stringify(val))
      },
      deep: true
    },
    selectedOffers: {
      handler (val) {
        this.selectedOfferIDs = val.map(a => a.id)
      },
      deep: true
    },
    search: {
      handler (val) {
        this.throttledLoadUnconfirmedOffers()
      },
      deep: true
    },
    searchCustomer: {
      handler (val) {
        console.log('searchCustomer data changed: ' + JSON.stringify(val))
        this.throttledLoadItems()
      },
      deep: true

    },
    'selectedItem.customers_id': {
      handler (val) {
        console.log('selectedCustomer data changed: ' + JSON.stringify(val))
        this.loadCustomerBranchOffices()
        this.loadUnconfirmedOffers()
      },
      deep: true

    },
    'selectedItem.customers_branch_offices_id': {
      handler (val) {
        console.log('selectedCustomerBranchOffice data changed: ' + JSON.stringify(val))
        this.loadCustomerBranchOfficesContacts()
      },
      deep: true

    }
  }

}
</script>

<style scoped>

    #menu-button {
        margin-top: 4px;
        width: 55px;
        height: 55px;
    }

    .fromTop {
        padding-top: 120px;
    }

    .fixSides::before {
        position: absolute;
        content: "";
        background-color: var(--secondary-color);
        height: 100%;
        width: 110vw;
        top: 0px;
        left: -24px;
    }

    .statusSelecter {
        width: 80px;
    }

    .header-switch {
      position: absolute;
      right: 24px;
    }

</style>



// WEBPACK FOOTER //
// src/components/Shared/AddPurchaseOrder.vue